// extracted by mini-css-extract-plugin
export default {"accordion":"Acoordion_accordion__Ps-hV","panel":"Acoordion_panel__H3s5y"};